module.exports = function isDomain(dom = '') {
	const domain = dom
		.replace('https', '')
		.replace('http', '')
		.replace('://', '');

	try {
		const url = new URL(`https://${domain}`);

		return !!url.host
			&& url.host.split('.').length > 1
			&& url.host.split('.').every(hst => !!hst.match(/[a-z]/i));

	} catch (e) {
		return false;
	}
};


// WEBPACK FOOTER //
// ./frontend/shared/js/isDomain.js